import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Typography, Box } from '@mui/material';
import { SubscriptionType } from 'entities/Subscriptions/types';
import { ColorPalette } from 'shared/consts/colorPalette';
import { IconButton } from 'shared/ui/IconButton';
import { getInfOrValue } from 'shared/helpers/getMaxValue';
import LimitPagesModal from './LimitPagesModal';

type LimitPagesProps = {
	subscription: SubscriptionType;
};

const LimitPages: FC<LimitPagesProps> = ({ subscription }) => {
	const { t } = useTranslation();
	const [open, setOpen] = useState(false);

	return (
		<>
			<LimitPagesModal open={open} handleClose={() => setOpen(false)} subscription={subscription} />

			<Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
				<Typography variant={'h6'} color={ColorPalette.astronaut}>
					{t('shared_texts.limit_pages')}
				</Typography>

				<Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
					<Typography variant={'body2'} color={ColorPalette.rockBlue}>
						{getInfOrValue(subscription.maxPagesWarningLimit)}
					</Typography>

					<IconButton
						iconId={'choose_subcategory'}
						sxWrapper={{
							height: 'auto',
							width: 'auto',
							backgroundColor: 'transparent',
						}}
						onClick={() => setOpen(true)}
					/>
				</Box>
			</Box>
		</>
	);
};

export default LimitPages;
